import React from "react";

export interface EntityOption {
  id: string;
  label: string;
  description: string;
  color: {
    selected: {
      border: string;
      bg: string;
      text: string;
      description: string;
    };
    unselected: {
      border: string;
      hover: {
        border: string;
        bg: string;
      };
    };
  };
}

interface EntitySelectorProps {
  selectedEntity: string;
  onEntityChange: (entityId: string) => void;
  options: EntityOption[];
}

export const EntitySelector: React.FC<EntitySelectorProps> = ({
  selectedEntity,
  onEntityChange,
  options,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-blue-100">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
        Seleccionar Entidad
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {options.map((option) => (
          <button
            key={option.id}
            onClick={() => onEntityChange(option.id)}
            className={`p-6 rounded-xl border-2 transition-all duration-200 ${
              selectedEntity === option.id
                ? `${option.color.selected.border} ${option.color.selected.bg} shadow-md`
                : `${option.color.unselected.border} ${option.color.unselected.hover.border} ${option.color.unselected.hover.bg}`
            }`}
          >
            <div className="text-center">
              <div className={`font-semibold ${option.color.selected.text}`}>
                {option.label}
              </div>
              <div
                className={`text-sm opacity-75 ${option.color.selected.description}`}
              >
                {option.description}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
